import PropTypes from 'prop-types'
import React from 'react'
import { FormattedMessage } from 'react-intl'
import HighlightTag from '../../../components/HighlightTag'

const propTypes = {
  /**
   * Class to override default styles
   */
  className: PropTypes.string,
  /**
   * Size of the tag
   */
  size: PropTypes.oneOf(['md', 'sm']),
}

const defaultProps = {
  className: '',
  size: 'md',
}

function NewTag(props) {
  const { className, size } = props

  return (
    <HighlightTag size={size} className={className}>
      <FormattedMessage id="GENERAL.NEW" />
    </HighlightTag>
  )
}

NewTag.propTypes = propTypes
NewTag.defaultProps = defaultProps

export default NewTag
